// Example Bootstrap JS usage (ensure bootstrap.bundle copied to /dist/vendor by Gulp)
document.addEventListener("DOMContentLoaded", () => {
  //console.log("PCM Theme JS loaded.");
});

// document.querySelectorAll('.ribbon .ticker').forEach(ticker => {
//   const first = ticker.querySelector('.ticker-track');
//   const clone = first.cloneNode(true);
//   clone.classList.add('clone');
//   clone.setAttribute('aria-hidden','true');
//   ticker.appendChild(clone);
// });

document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".home-services");
  const center = section?.querySelector(".home-services-heading-div");
  const container = center?.closest(".container-fluid");
  if (!container || !center) return;

  // collect original card nodes in source order
  const origCards = Array.from(
    container.querySelectorAll(":scope > .card-div"),
  );
  if (!origCards.length) return;

  // rails elems (created on-demand)
  let leftCol = null,
    rightCol = null;

  // --- AOS + sticky gating: wait for image to animate in (or at least load) ---
  const heroImg = center.querySelector(".mobile-device-img");
  const activateStickyAndAOS = () => {
    center.classList.add("is-sticky"); // CSS makes it sticky on md–lg
    document.dispatchEvent(new Event("homeReady")); // AOS init below uses this
  };

  if (window.AOS && typeof AOS.init === "function") {
    // AOS won’t run until we dispatch 'homeReady'
    AOS.init({ startEvent: "homeReady" });
  }

  const onAOSIn = (e) => {
    const el = e.detail;
    if (el && el.classList?.contains("mobile-device-img")) {
      document.removeEventListener("aos:in", onAOSIn);
      activateStickyAndAOS();
    }
  };
  document.addEventListener("aos:in", onAOSIn);

  if (heroImg) {
    if (!heroImg.complete) {
      heroImg.addEventListener("load", () => activateStickyAndAOS(), {
        once: true,
      });
    } else {
      requestAnimationFrame(activateStickyAndAOS);
    }
  } else {
    // no image, don’t block layout
    activateStickyAndAOS();
  }

  // --- Rails (XL+) ---
  const cfg = {
    leftShift: 220, // px upward travel for LEFT rail
    rightShift: 360, // px upward travel for RIGHT rail
    startPadVh: 0,
    endPadVh: 10,
  };
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)");
  const mqXL = window.matchMedia("(min-width: 1200px)"); // XL+
  const mqMDLG = window.matchMedia(
    "(min-width: 768px) and (max-width: 1199.98px)",
  );

  const lerp = (a, b, t) => a + (b - a) * t;

  const updateParallax = () => {
    if (!leftCol || !rightCol) return;
    const rect = container.getBoundingClientRect();
    const vh = window.innerHeight;
    const start = vh * (cfg.startPadVh / 100);
    const end = Math.max(1, rect.height - vh * (cfg.endPadVh / 100));
    const y = Math.min(Math.max(-rect.top - start, 0), end);
    const t = y / end;
    leftCol.style.transform = `translateY(${-lerp(0, cfg.leftShift, t).toFixed(2)}px)`;
    rightCol.style.transform = `translateY(${-lerp(0, cfg.rightShift, t).toFixed(2)}px)`;
  };

  const addRails = () => {
    if (leftCol || rightCol) return; // already added
    container.classList.add("services-rail");

    leftCol = document.createElement("div");
    rightCol = document.createElement("div");
    leftCol.className = "cards-col cards-left";
    rightCol.className = "cards-col cards-right";

    // insert around the sticky center
    container.insertBefore(leftCol, center); // left before center
    container.insertBefore(rightCol, center.nextSibling); // right after center

    // distribute cards alternately to balance columns
    origCards.forEach((card, i) =>
      (i % 2 ? rightCol : leftCol).appendChild(card),
    );

    // parallax listeners
    if (!prefersReduced.matches) {
      updateParallax();
      window.addEventListener("scroll", updateParallax, { passive: true });
      window.addEventListener("resize", updateParallax);
    }
  };

  const removeRails = () => {
    if (!leftCol && !rightCol) return;

    // detach listeners
    window.removeEventListener("scroll", updateParallax);
    window.removeEventListener("resize", updateParallax);

    // return cards to original container in original DOM order
    origCards.forEach((card) => container.appendChild(card));

    // remove rails nodes
    leftCol?.remove();
    rightCol?.remove();
    leftCol = rightCol = null;

    container.classList.remove("services-rail");
    container.style.removeProperty("transform");
  };

  // Apply mode based on breakpoints:
  // - XS (<768): no rails, simple stack (CSS handles)
  // - MD–LG (768–1199.98): no rails; CSS grid puts sticky left + cards right
  // - XL+ (≥1200): use rails/parallax
  const applyMode = () => {
    if (mqXL.matches) {
      addRails();
    } else {
      removeRails();
      // No DOM shuffle here; CSS does the layout for xs and md–lg.
    }
  };

  // initial and reactive
  applyMode();
  mqXL.addEventListener("change", applyMode);
  mqMDLG.addEventListener("change", applyMode);
  prefersReduced.addEventListener?.("change", () => {
    // re-init parallax listeners according to new preference
    if (mqXL.matches) {
      removeRails();
      addRails();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Target the two galleries inside your About section
  const galleries = document.querySelectorAll(
    ".about-statement-group .wp-block-gallery",
  );

  if (!galleries.length) return;

  galleries.forEach((gal, i) => {
    // Wrap in a scroller
    const scroller = document.createElement("div");
    scroller.className = "scroller";

    // Left scrolls up, right scrolls down
    // (Your markup has wp-block-gallery-1 on the left, -2 on the right)
    if (gal.classList.contains("wp-block-gallery-2") || i === 1) {
      scroller.setAttribute("data-direction", "down");
    }

    // Build a track and move children into it twice for seamless loop
    const track = document.createElement("div");
    track.className = "gallery-track";

    // Collect figure children (images are inside <figure>)
    const items = Array.from(gal.children);
    items.forEach((el) => track.appendChild(el.cloneNode(true)));
    items.forEach((el) => track.appendChild(el.cloneNode(true)));

    // Replace original gallery content with our scroller/track
    gal.innerHTML = "";
    gal.appendChild(scroller);
    scroller.appendChild(track);

    // Function to measure and set animation duration based on content height
    const setDuration = () => {
      const isMobile = window.innerWidth <= 991;

      // first half duplicated set
      const half = Array.from(track.children).slice(
        0,
        track.children.length / 2,
      );

      let total = 0;

      if (isMobile) {
        // horizontal length
        half.forEach((el) => (total += el.getBoundingClientRect().width));
      } else {
        // vertical height
        half.forEach((el) => (total += el.getBoundingClientRect().height));
      }

      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const totalWithGaps = total + gap * (half.length - 1);

      const pxPerSecond = 30; // adjust slower/faster
      const duration = (totalWithGaps / pxPerSecond) * 2;

      track.style.setProperty("--duration", `${duration.toFixed(2)}s`);
    };

    // Recalc when images load & on resize
    const imgs = track.querySelectorAll("img");
    let pending = imgs.length;
    if (pending === 0) setDuration();
    imgs.forEach((img) => {
      if (img.complete) {
        if (--pending === 0) setDuration();
      } else {
        img.addEventListener("load", () => {
          if (--pending === 0) setDuration();
        });
        img.addEventListener("error", () => {
          if (--pending === 0) setDuration();
        });
      }
    });

    window.addEventListener("resize", () => {
      // Debounce a bit
      clearTimeout(scroller._resizeTO);
      scroller._resizeTO = setTimeout(setDuration, 150);
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const mq = window.matchMedia("(min-width: 992px)");

  function getMiddleCol() {
    // Prefer the inner middle column wrapper if present, else 2nd column
    return (
      // document.querySelector(".about-statement-group .about-statement-columns") ||
      document.querySelector(".about-statement-col")
    );
  }

  function syncHeights() {
    const scrollers = document.querySelectorAll(
      ".about-statement-group .scroller",
    );
    if (!scrollers.length) return;

    if (!mq.matches) {
      // <992: remove any desktop-only sizing
      scrollers.forEach((el) => el.style.removeProperty("--about-sync-height"));
      return;
    }

    const middle = getMiddleCol();
    if (!middle) return;

    const h = middle.getBoundingClientRect().height;
    scrollers.forEach((el) =>
      el.style.setProperty("--about-sync-height", `${h}px`),
    );
  }

  // run now, after load, and on resize/breakpoint changes
  const debounced = (() => {
    let to;
    return () => {
      clearTimeout(to);
      to = setTimeout(syncHeights, 120);
    };
  })();

  syncHeights();
  window.addEventListener("load", syncHeights);
  window.addEventListener("resize", debounced);
  mq.addEventListener
    ? mq.addEventListener("change", syncHeights)
    : mq.addListener(syncHeights);

  // Recalculate as images finish loading
  document.querySelectorAll(".about-statement-group img").forEach((img) => {
    if (!img.complete) img.addEventListener("load", debounced, { once: true });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  // Remove leftover offcanvas/modal toggles that can crash on click
  document
    .querySelectorAll('[data-bs-toggle="offcanvas"],[data-bs-toggle="modal"]')
    .forEach((el) => {
      // Keep real modals if you actually use them; otherwise nuke all
      el.removeAttribute("data-bs-toggle");
      el.removeAttribute("data-bs-target");
      el.removeAttribute("aria-controls");
    });

  // Optional: log anything we removed so you can fix markup/themes later
  // console.log('Sanitized toggles:', document.querySelectorAll('[data-bs-toggle="offcanvas"],[data-bs-toggle="modal"]'));
});
document.addEventListener("DOMContentLoaded", () => {
  const navEl = document.getElementById("mainNav");
  const toggler = document.querySelector(".navbar-toggler");

  if (!navEl || !toggler || !window.bootstrap || !bootstrap.Collapse) return;

  const collapse = bootstrap.Collapse.getOrCreateInstance(navEl, {
    toggle: false,
  });

  // Close the menu when a nav link (or dropdown item) is clicked on mobile
  navEl.addEventListener("click", (e) => {
    const link = e.target.closest(".nav-link, .dropdown-item");
    if (!link) return;
    if (getComputedStyle(toggler).display !== "none") collapse.hide();
  });
});

document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-scroll-to]");
  if (!btn) return;
  document
    .querySelector(btn.dataset.scrollTo)
    ?.scrollIntoView({ behavior: "smooth" });
});

(function () {
  function initReviewToggle(scope) {
    const btn = document.getElementById("add-review-btn");
    const panel = document.getElementById("add-review-panel");

    if (!btn || !panel || btn.dataset.reviewToggleReady === "1") return;

    btn.dataset.reviewToggleReady = "1";
    btn.setAttribute(
      "aria-expanded",
      panel.hasAttribute("hidden") ? "false" : "true",
    );
    btn.setAttribute("aria-controls", "add-review-panel");

    btn.addEventListener("click", function () {
      const isHidden = panel.hasAttribute("hidden");

      if (isHidden) {
        panel.removeAttribute("hidden");
        btn.textContent = "Hide Review Form";
        btn.setAttribute("aria-expanded", "true");
      } else {
        panel.setAttribute("hidden", "");
        btn.textContent = "Add a Review";
        btn.setAttribute("aria-expanded", "false");
      }
    });
  }

  function initStarRatings(scope) {
    const root = scope || document;

    root
      .querySelectorAll(".gfield.rating-field .gfield_radio")
      .forEach(function (group) {
        if (group.dataset.starReady === "1") return;
        group.dataset.starReady = "1";

        const choices = Array.from(group.querySelectorAll(".gchoice"));
        if (!choices.length) return;

        group.classList.add("star-rating");

        function getSelectedValue() {
          const checked = group.querySelector('input[type="radio"]:checked');
          return checked ? parseInt(checked.value, 10) || 0 : 0;
        }

        function paint(selectedValue, hoverValue) {
          const activeValue = hoverValue || selectedValue || 0;

          choices.forEach(function (choice, index) {
            const starNumber = index + 1;
            const label = choice.querySelector("label");
            if (!label) return;

            label.textContent = "★";

            choice.classList.toggle("is-active", starNumber <= activeValue);
            choice.classList.toggle("is-selected", starNumber <= selectedValue);
            choice.classList.toggle("is-current", starNumber === selectedValue);
          });
        }

        choices.forEach(function (choice, index) {
          const input = choice.querySelector('input[type="radio"]');
          const label = choice.querySelector("label");

          if (!input || !label) return;

          choice.setAttribute("data-rating", String(index + 1));
          choice.setAttribute("tabindex", "0");

          choice.addEventListener("mouseenter", function () {
            paint(getSelectedValue(), index + 1);
          });

          choice.addEventListener("click", function () {
            input.checked = true;
            input.dispatchEvent(new Event("change", { bubbles: true }));
            paint(getSelectedValue(), 0);
          });

          choice.addEventListener("keydown", function (e) {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              input.checked = true;
              input.dispatchEvent(new Event("change", { bubbles: true }));
              paint(getSelectedValue(), 0);
            }
          });

          input.addEventListener("change", function () {
            paint(getSelectedValue(), 0);
          });
        });

        group.addEventListener("mouseleave", function () {
          paint(getSelectedValue(), 0);
        });

        paint(getSelectedValue(), 0);
      });
  }

  function initAll(scope) {
    initReviewToggle(document);
    initStarRatings(scope || document);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  document.addEventListener("gform/post_render", function (event) {
    initAll(event.target || document);
  });

  // ADD IT HERE
  document.addEventListener("gform_confirmation_loaded", function (event) {
    let formId = 0;

    if (event.detail && event.detail.formId) {
      formId = parseInt(event.detail.formId, 10);
    }

    if (formId !== 9) return;

    const btn = document.getElementById("add-review-btn");
    if (!btn) return;

    btn.style.display = "none";
  });
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;

        if (
          node.matches(".gform_confirmation_wrapper") ||
          node.querySelector(".gform_confirmation_wrapper")
        ) {
          const btn = document.getElementById("add-review-btn");
          if (btn) {
            btn.style.display = "none";
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  const usStates = [
    'Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut',
    'Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa',
    'Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan',
    'Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada',
    'New Hampshire','New Jersey','New Mexico','New York','North Carolina',
    'North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island',
    'South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont',
    'Virginia','Washington','West Virginia','Wisconsin','Wyoming'
  ];

  // 🔥 Abbreviation → Full name map
  const stateMap = {
    AL:'Alabama', AK:'Alaska', AZ:'Arizona', AR:'Arkansas', CA:'California',
    CO:'Colorado', CT:'Connecticut', DE:'Delaware', FL:'Florida', GA:'Georgia',
    HI:'Hawaii', ID:'Idaho', IL:'Illinois', IN:'Indiana', IA:'Iowa',
    KS:'Kansas', KY:'Kentucky', LA:'Louisiana', ME:'Maine', MD:'Maryland',
    MA:'Massachusetts', MI:'Michigan', MN:'Minnesota', MS:'Mississippi',
    MO:'Missouri', MT:'Montana', NE:'Nebraska', NV:'Nevada',
    NH:'New Hampshire', NJ:'New Jersey', NM:'New Mexico', NY:'New York',
    NC:'North Carolina', ND:'North Dakota', OH:'Ohio', OK:'Oklahoma',
    OR:'Oregon', PA:'Pennsylvania', RI:'Rhode Island', SC:'South Carolina',
    SD:'South Dakota', TN:'Tennessee', TX:'Texas', UT:'Utah',
    VT:'Vermont', VA:'Virginia', WA:'Washington', WV:'West Virginia',
    WI:'Wisconsin', WY:'Wyoming'
  };

  function normalizeState(value) {
    if (!value) return '';
    const upper = value.toUpperCase().trim();

    // If it's abbreviation → convert
    if (stateMap[upper]) return stateMap[upper];

    return value;
  }

  function enhanceAddressStateFields() {
    document.querySelectorAll('select[id^="input_"][id$="_6"]').forEach(function (countrySelect) {

      const countryId = countrySelect.id;
      const stateId = countryId.replace(/_6$/, '_4');

      let stateField = document.getElementById(stateId);
      if (!stateField) return;

      if (stateField.dataset.gfStateEnhanced === '1') return;
      stateField.dataset.gfStateEnhanced = '1';

      const originalInput = stateField;

      // 🔥 normalize here
      const originalValue = normalizeState(originalInput.value || '');

      const select = document.createElement('select');
      select.id = originalInput.id;
      select.name = originalInput.name;
      select.className = originalInput.className;
      select.setAttribute('aria-label', originalInput.getAttribute('aria-label') || 'State');

      select.innerHTML = '<option value="">Select State</option>';

      usStates.forEach(function (state) {
        const option = document.createElement('option');
        option.value = state;
        option.textContent = state;

        if (state === originalValue) {
          option.selected = true;
        }

        select.appendChild(option);
      });

      function toggleStateField() {
        const country = countrySelect.value;
        const currentField = document.getElementById(stateId);

        if (country === 'United States') {
          if (currentField && currentField.tagName !== 'SELECT') {
            currentField.replaceWith(select);
          }
        } else {
          if (currentField && currentField.tagName !== 'INPUT') {
            currentField.replaceWith(originalInput);
          }
        }
      }

      countrySelect.addEventListener('change', toggleStateField);
      toggleStateField();
    });
  }

  enhanceAddressStateFields();

  document.addEventListener('gform_post_render', enhanceAddressStateFields);
  document.addEventListener('gform/ajax/post_ajax_submission', enhanceAddressStateFields);
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.aos-fade-up').forEach(function (el) {
    el.setAttribute('data-aos', 'fade-up');
    el.setAttribute('data-aos-duration', '800');
  });
  document.querySelectorAll('.aos-fade-in').forEach(function (el) {
    el.setAttribute('data-aos', 'fade-in');
  });
    
  document.querySelectorAll('.aos-delay-100').forEach(function (el) {
    el.setAttribute('data-aos-delay', '100');
  });

  document.querySelectorAll('.aos-delay-200').forEach(function (el) {
    el.setAttribute('data-aos-delay', '200');
  });

  document.querySelectorAll('.aos-delay-300').forEach(function (el) {
    el.setAttribute('data-aos-delay', '300');
  });
  document.querySelectorAll('.aos-delay-400').forEach(function (el) {
    el.setAttribute('data-aos-delay', '400');
  });
  document.querySelectorAll('.aos-delay-500').forEach(function (el) {
    el.setAttribute('data-aos-delay', '500');
  });
  document.querySelectorAll('.aos-delay-600').forEach(function (el) {
    el.setAttribute('data-aos-delay', '600');
  });

  if (typeof AOS !== 'undefined') {
    AOS.init({
      duration: 700,
      easing: 'ease-out-cubic',
      once: false,
      mirror: true,
      offset: 80
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
	const mobileBreakpoint = 992;

	document
		.querySelectorAll('.navbar .menu-item-has-children > a')
		.forEach((link) => {
			link.addEventListener('click', (event) => {
				if (window.innerWidth >= mobileBreakpoint) {
					return;
				}

				event.preventDefault();
				event.stopPropagation();

				const menuItem = link.closest('.menu-item-has-children');
				const submenu = menuItem?.querySelector(':scope > .sub-menu');

				if (!submenu) {
					return;
				}

				const isOpen = menuItem.classList.contains('submenu-open');

				/*
				 * Close sibling submenus, but do not collapse
				 * the entire mobile navigation.
				 */
				menuItem.parentElement
					?.querySelectorAll(':scope > .menu-item-has-children.submenu-open')
					.forEach((sibling) => {
						if (sibling === menuItem) {
							return;
						}

						sibling.classList.remove('submenu-open');

						const siblingLink = sibling.querySelector(':scope > a');
						siblingLink?.setAttribute('aria-expanded', 'false');
					});

				menuItem.classList.toggle('submenu-open', !isOpen);
				link.setAttribute('aria-expanded', String(!isOpen));
			});
		});
});

const avatarForm =
  document.querySelector('.pcm-fluent-avatar-form');

const avatarInput =
  avatarForm?.querySelector('.pcm-avatar-file');

if (avatarForm && avatarInput) {
  avatarInput.addEventListener('change', function () {

    if (!this.files || !this.files.length) {
      return;
    }

    const avatar =
      document.querySelector('.pcm-account-avatar');

    if (avatar) {
      avatar.classList.add('is-uploading');

      const spinner =
        document.createElement('div');

      spinner.className = 'pcm-avatar-spinner';
      spinner.setAttribute('aria-label', 'Uploading profile image');
      spinner.setAttribute('role', 'status');

      avatar.appendChild(spinner);
    }

    avatarForm.submit();
  });
}